import { MarketingButton } from '@/components/marketing/marketing-button'
import { MarketingEyebrow } from '@/components/marketing/marketing-eyebrow'
import { MARKETING_DISPLAY_TITLE } from '@/components/marketing/marketing-typography'
import { LumieOrb } from '@/components/landing/lumie/lumie-brand-mark'
import { MarketingContentFrame } from '@/landing/marketing-content-frame'
import { cn } from '@/lib/utils'

const DATA_PILLS = [
  { label: 'Medical records', className: 'left-[50px] top-[55px]' },
  { label: 'Wearables', className: 'right-3 top-[115px]' },
  { label: 'Symptoms', className: 'bottom-[170px] left-2.5' },
  { label: 'Medications', className: 'bottom-[126px] right-[30px]' },
  { label: 'Pathology', className: 'bottom-11 left-[125px]' },
  { label: 'Sleep', className: 'left-[-10px] top-[250px] max-lg:hidden' },
  { label: 'Mood', className: 'right-[-4px] top-[275px] max-lg:hidden' },
] as const

export function LumieOrbHero() {
  return (
    <MarketingContentFrame shellClassName="pb-[90px] pt-[72px]">
      <div className="grid min-h-[70vh] items-center gap-[60px] lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <MarketingEyebrow>Patient-owned health intelligence</MarketingEyebrow>
          <h1 className={cn('mb-6 max-w-[880px]', MARKETING_DISPLAY_TITLE)}>
            Your health data is everywhere. Lumie brings it together.
          </h1>
          <p className="mb-8 max-w-[650px] text-lg leading-relaxed text-[var(--marketing-muted,#667078)]">
            Lumie connects your records, wearables, symptoms, medications and lifestyle data into one intelligent
            health story.
          </p>
          <div className="flex flex-wrap items-center gap-3.5">
            <MarketingButton href="#waitlist">Get early access</MarketingButton>
            <MarketingButton href="#features" variant="light">
              See how it works
            </MarketingButton>
          </div>
          <p className="mt-[22px] text-sm text-[var(--marketing-muted,#667078)]">
            Built for patients first. Designed to support better conversations with healthcare teams.
          </p>
        </div>

        <div
          className="relative flex min-h-[470px] items-center justify-center lg:min-h-[570px]"
          aria-label="Lumie health data visualisation"
        >
          {DATA_PILLS.map((pill) => (
            <span
              key={pill.label}
              className={cn(
                'absolute z-[3] rounded-full border border-[var(--marketing-border,#e9e3d6)]',
                'bg-[var(--marketing-card,#ffffff)]/80 px-[15px] py-[11px] text-sm font-semibold text-[var(--marketing-text,#3d464b)] backdrop-blur-md',
                'shadow-[0_20px_60px_rgba(31,37,40,0.08)] max-sm:text-xs max-sm:px-3 max-sm:py-2',
                pill.className
              )}
            >
              {pill.label}
            </span>
          ))}
          <LumieOrb size="lg" className="relative z-[2]" />
        </div>
      </div>
    </MarketingContentFrame>
  )
}
